import { Multimedia } from '@web/shared/module/multimedia';
import { Guid, Nillable } from '@web/utils';

export class PublicBrandBannerCollectionItem {
  public constructor(
    private readonly data: {
      file: Multimedia;
      id: Guid;
      smallFile?: Nillable<Multimedia>;
      url?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get file(): Multimedia {
    return this.data.file;
  }

  public get smallFile(): Nillable<Multimedia> {
    return this.data.smallFile;
  }
}
